// Picture lookup. Page artwork lives in src/assets/img/sanasa (see content/image-plan.md for where each one comes from).
// Photos of programs, events, news, people and the hero slides come from Supabase Storage.
import { publicFileUrl } from '../lib/supabase';

const ctx = require.context('../assets/img/sanasa', true, /\.(jpe?g|png|svg)$/);
const img = (path) => {
  const m = ctx(`./${path}`);
  return m.default || m;
};

export const offerBackground = img('backgrounds/offer-bg.jpg');
export const breadcrumbBackground = img('backgrounds/breadcrumb.jpg');
export const homeAbout = [img('home/about-1.jpg'), img('home/about-2.jpg')];
export const homeTestimonial = img('home/testimonial.jpg');
export const aboutPage = [img('about/a1.jpg'), img('about/a2.jpg'), img('about/a3.jpg')];
export const researchImages = [img('research/research-1.jpg'), img('research/research-2.jpg')];
export const faqImage = img('faq/faq.jpg');
export const categoryIcons = {
  banking: img('icons/banking.svg'),
  insurance: img('icons/insurance.svg'),
  planning: img('icons/planning.svg'),
  diplomas: img('icons/diplomas.svg'),
  training: img('icons/training.svg'),
};
export const gallery = Array.from({ length: 8 }, (_, i) => img(`gallery/g${i + 1}.jpg`));
export const initialsAvatars = [img('avatars/sg.png'), img('avatars/lc.png'), img('avatars/hm.png'), img('avatars/bu.png')];
export const sanasaAvatar30 = img('avatars/sanasa-30.png');
export const sanasaAvatar40 = img('avatars/sanasa-40.png');

// ---------- photos that come from the database (Supabase "media" bucket) ----------
// A record stores either one file ('people/abeyratne.jpg') or a base name for a family of sizes
// ('news/landslide-survey-2023'), and the site adds -card.jpg, -wide.jpg and so on for each slot.
// A record with no photo yet shows a bundled picture so no slot is ever empty.
const media = (path) => publicFileUrl('media', path);
const family = (base, sizes) => {
  const out = {};
  Object.entries(sizes).forEach(([slot, suffix]) => {
    out[slot] = base ? media(`${base}${suffix}.jpg`) : img(`fallback/picture-${slot === 'card' ? 'card' : slot === 'side' ? 'side' : 'wide'}.jpg`);
  });
  return out;
};

export const mediaPicture = (path) => (path ? media(path) : img('fallback/picture-wide.jpg'));
export const heroPicture = (path) => (path ? media(path) : img('fallback/picture-wide.jpg'));
export const programImages = (p) => family(p && p.imagePath, { card: '-card', wide: '-wide', side: '-side' });
export const eventImages = (e) => family(e && e.imagePath, { card: '-card', wide: '-wide', side: '-side' });
export const newsImages = (n) =>
  family(n && n.imagePath, { card: '-card', home: '-home', main: '-main', a: '-a', b: '-b', thumb: '-thumb' });
export const personPhoto = (person) => (person && person.photoPath ? media(person.photoPath) : img('fallback/person.jpg'));
export const photoFromPath = (path) => (path ? media(path) : img('fallback/person.jpg'));
